export default {
  nl: {
    meterkast: {
      ctaTitle: 'Maak je meterkast veiliger en beter',
      ctaBody: 'Maak je meterkast veiliger en beter. Laat je meterkast vooraf bekijken. Het bezoek kan dan beter voorbereid worden en je ontvangt een rapport met een analyse over je meterkast.',
      ctaButton: 'Start verbetering',

      captureTitle: 'Foto\'s van je meterkast',
      captureBody: 'Maak duidelijke foto\'s van je meterkast. Zorg dat alles goed zichtbaar is. Je kunt maximaal 5 foto\'s toevoegen.',
      addPhoto: 'Foto toevoegen',
      takePhoto: 'Foto maken',
      chooseFromLibrary: 'Kies uit galerij',
      closeCamera: 'Camera sluiten',
      cameraUnavailable: 'Camera niet beschikbaar. Gebruik de optie hieronder om een foto te kiezen.',
      removePhoto: 'Foto verwijderen',
      photoError: 'We konden deze foto niet verwerken. Probeer een andere foto.',
      maxPhotos: 'Je kunt maximaal {{max}} foto\'s toevoegen.',
      photoExamplesLink: 'Hoe moeten de foto\'s eruitzien?',
      photoExamplesGood: 'Goede voorbeelden',
      photoExamplesBad: 'Slecht voorbeeld',
      photoExamplesGoodOverview: 'Overzicht van de hele meterkast',
      photoExamplesGoodDetail: 'Gedetailleerde close-up als extra foto',
      photoExamplesBadCaption: 'Houd de meterkast in beeld. Fotografeer geen andere spullen in de kast.',
      photoExamplesClose: 'Sluiten',

      consentTitle: 'Toestemming',
      consentBody: 'Wij gebruiken je foto\'s alleen om je meterkast te analyseren en passende verbeteringen voor te stellen.',
      consentCheckbox: 'Ik geef toestemming om mijn foto\'s te gebruiken voor analyse',
      privacyConsentCheckbox: 'Ik bevestig dat ik het privacybeleid heb gelezen en aanvaard.',
      privacyPolicyLink: 'Lees de privacyverklaring',

      submitButton: 'Verstuur foto\'s',
      noEmailError: 'We hebben geen e-mailadres voor je afspraak. Neem contact met ons op zodat we je rapport kunnen versturen.',
      uploadError: 'Het versturen van je foto\'s is mislukt. Probeer het opnieuw.',

      scheduledTitle: 'Bedankt! We gaan ermee aan de slag.',
      scheduledBody: 'We analyseren je foto\'s en sturen je rapport per e-mail. Je hoort binnen ongeveer een week van ons. Je hoeft verder niets te doen.',
      scheduledBack: 'Terug naar afspraak',

      privacyPolicy: `
# Privacyverklaring & Disclaimer — Elektrische Kast Inspectieservice

Guidion B.V. | Versie: juni 2026

## 1. Inleiding

Guidion B.V. biedt een digitale inspectieservice aan waarmee gebruikers foto's van hun elektrische kast kunnen uploaden. Op basis van deze foto's genereert ons systeem — met behulp van kunstmatige intelligentie — een overzicht van mogelijke aandachtspunten en verbeterpunten (het Rapport).

Door gebruik te maken van de service verklaart u deze Privacyverklaring & Disclaimer te hebben gelezen, begrepen en aanvaard.

## 2. Verwerkingsverantwoordelijke

Guidion B.V.

James Wattstraat 77-M, 1097 DL Amsterdam, Nederland

[privacy@guidion.net](mailto:privacy@guidion.net)

[https://www.guidion.com](https://www.guidion.com)

## 3. Welke gegevens verwerken wij?

* Foto's van uw elektrische kast
* Technische metadata (tijdstip, bestandsformaat, apparaatinformatie)
* Persoonsgegevens zichtbaar op de foto's (bijv. namen op componenten of adreslabels)
* Contactgegevens die u verstrekt bij gebruik van de service

## 4. Doeleinden en rechtsgronden

### 4.1 Levering van de inspectieservice

Wij verwerken uw foto's om het Rapport te genereren. Rechtsgrond: uitvoering van de overeenkomst (art. 6 lid 1 sub b AVG).

### 4.2 Bewaring en hergebruik van foto's

Met uw uitdrukkelijke toestemming bewaren wij foto's voor:

* Training, verbetering en validatie van onze AI-modellen
* Kwaliteitscontrole en doorontwikkeling van onze dienstverlening
* Intern onderzoek naar veiligheidsstandaarden voor elektrische installaties
* Geanonimiseerde statistische analyse

Rechtsgrond: uw toestemming (art. 6 lid 1 sub a AVG). U kunt uw toestemming te allen tijde intrekken.

### 4.3 Rechtenafstand op foto's

U verleent Guidion de noodzakelijke gebruiksrechten om de foto's te verwerken voor de in artikel 4.2 genoemde doeleinden, zolang uw toestemming van kracht is. Guidion zal foto's niet verkopen aan derden of openbaar publiceren op een herleidbare wijze.

## 5. Bewaartermijn

Guidion bewaart de foto's zolang deze noodzakelijk zijn voor de in artikel 4.2 genoemde doeleinden, met een maximale termijn van 2 jaar, of tot het moment dat u uw toestemming intrekt of een verwijderingsverzoek indient.


## 6. Disclaimer — Aard en beperkingen van het Rapport

Lees dit gedeelte zorgvuldig. Het Rapport is uitsluitend informatief en mag niet worden gebruikt als officieel keuringsdocument.

### 6.1 Het Rapport is uitsluitend informatief van aard

Het Rapport is een geautomatiseerd gegenereerd overzicht van mogelijke aandachtspunten op basis van de aangeleverde foto's. Het is bedoeld als oriënterende samenvatting voor persoonlijk gebruik.

### 6.2 Het Rapport is géén professioneel keuringsrapport

Het Rapport is nadrukkelijk niet:

* Een officieel keuringsrapport conform NEN 1010, NEN 3140 of andere normen
* Een verklaring van een erkende keuringsinstantie of gecertificeerd installateur
* Een professioneel advies van een gekwalificeerde elektricien
* Een conformiteits- of veiligheidsverklaring voor welk doel dan ook

### 6.3 Het Rapport is niet juridisch bindend

Het Rapport kan niet worden gebruikt als:

* Bewijsmiddel in juridische of bestuursrechtelijke procedures
* Documentatie voor verzekeringsclaims of het afsluiten van verzekeringen
* Vereiste documentatie bij hypotheekverstrekking, verkoop of verhuur van onroerend goed
* Verplicht keuringsrapport op grond van wet- of regelgeving

### 6.4 Beperkingen van AI-analyse

Het AI-systeem analyseert uitsluitend op basis van visuele informatie. Guidion staat niet in voor de volledigheid of juistheid van de bevindingen. Factoren die niet zichtbaar zijn op foto's — zoals verborgen bekabeling of slijtage achter de installatie — worden niet gedetecteerd.

### 6.5 Aanbeveling

Bij twijfel over de veiligheid van uw elektrische installatie: schakel altijd een erkend en gecertificeerd elektrotechnisch installateur of keuringsinstantie in.

## 7. Aansprakelijkheidsbeperking

Guidion aanvaardt geen aansprakelijkheid voor schade voortvloeiend uit:

* Het gebruik van of vertrouwen op de inhoud van het Rapport
* Onjuiste bevindingen als gevolg van de kwaliteit van de aangeleverde foto's
* Handelingen ondernomen op basis van het Rapport
* Technische storingen of fouten in de service

De totale aansprakelijkheid van Guidion is beperkt tot het betaalde bedrag, of bij een gratis service tot €100,—.

## 8. Uw rechten onder de AVG

U heeft het recht op:

* Inzage in uw gegevens (art. 15 AVG)
* Rectificatie van onjuiste gegevens (art. 16 AVG)
* Gegevenswissing — "recht op vergetelheid" (art. 17 AVG)
* Beperking van de verwerking (art. 18 AVG)
* Gegevensoverdraagbaarheid (art. 20 AVG)
* Bezwaar tegen verwerking (art. 21 AVG)
* Intrekking van toestemming te allen tijde (art. 7 lid 3 AVG)

Verzoeken indienen via: [privacy@guidion.com](mailto:privacy@guidion.com)

Klachten: [www.autoriteitpersoonsgegevens.nl](https://www.autoriteitpersoonsgegevens.nl)

## 9. Beveiliging

Guidion neemt passende technische en organisatorische maatregelen conform de AVG en ISO 27001 om uw gegevens te beveiligen.


## 10. Wijzigingen

Guidion behoudt zich het recht voor deze verklaring te wijzigen. Wezenlijke wijzigingen worden vooraf aangekondigd via de website of per e-mail.

---

Als u vragen heeft over deze privacyverklaring of meer wil weten over de manier waarop Guidion met uw persoonsgegevens omgaat of wat uw rechten met betrekking tot uw persoonsgegevens zijn, kunt u contact opnemen met onze privacy afdeling via privacy@guidion.net.

Als dit niet leidt tot een oplossing of onze reactie niet wil afwachten, dan kunt u gebruik maken van het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens via het online klachtenformulier op de website [https://www.autoriteitpersoonsgegevens.nl/een-tip-of-klacht-indienen-bij-de-ap](https://www.autoriteitpersoonsgegevens.nl/een-tip-of-klacht-indienen-bij-de-ap)).

© 2026 Guidion B.V. — Alle rechten voorbehouden.
`,
    },
  },
  en: {
    meterkast: {
      ctaTitle: 'Make your meter cabinet safer and better',
      ctaBody: 'Make your meter cabinet safer and better. Have your meter cabinet reviewed in advance. This allows the visit to be better prepared, and you\'ll receive a report with an analysis of your meter cabinet.',
      ctaButton: 'Start improvement',

      captureTitle: 'Photos of your meter cabinet',
      captureBody: 'Take clear photos of your meter cabinet. Make sure everything is fully visible. You can add up to 5 photos.',
      addPhoto: 'Add photo',
      takePhoto: 'Take photo',
      chooseFromLibrary: 'Choose from library',
      closeCamera: 'Close camera',
      cameraUnavailable: 'Camera not available. Use the option below to choose a photo.',
      removePhoto: 'Remove photo',
      photoError: 'We couldn\'t process this photo. Please try a different one.',
      maxPhotos: 'You can add a maximum of {{max}} photos.',
      photoExamplesLink: 'How should the photos look like?',
      photoExamplesGood: 'Good examples',
      photoExamplesBad: 'Bad example',
      photoExamplesGoodOverview: 'An overview of the entire meter cabinet',
      photoExamplesGoodDetail: 'A detailed close-up as an extra photo for details',
      photoExamplesBadCaption: 'Keep the meter cabinet in frame and avoid photographing other items in the cabinet.',
      photoExamplesClose: 'Close',

      consentTitle: 'Permission',
      consentBody: 'We only use your photos to analyse your meter cabinet and propose suitable improvements.',
      consentCheckbox: 'I give permission to use my photos for analysis',
      privacyConsentCheckbox: 'I acknowledge that I have read and accept the privacy policy',
      privacyPolicyLink: 'Read the privacy policy',

      submitButton: 'Send photos',
      noEmailError: 'We don\'t have an email address for your appointment. Please contact us so we can send you your report.',
      uploadError: 'Sending your photos failed. Please try again.',

      scheduledTitle: 'Thank you! We\'re getting started.',
      scheduledBody: 'We\'ll analyse your photos and email your report. You\'ll hear back from us within about a week. You don\'t need to do anything else.',
      scheduledBack: 'Back to appointment',

      privacyPolicy: `
# Privacy Statement & Disclaimer — Electrical Cabinet Inspection Service

Guidion B.V. | Version: June 2026

## 1. Introduction

Guidion B.V. offers a digital inspection service that allows users to upload photos of their electrical cabinet. Based on these photos, our system generates an overview of potential points of attention and improvement areas (the Report) utilizing artificial intelligence.

By using this service, you declare that you have read, understood, and accepted this Privacy Statement & Disclaimer.

## 2. Data Controller

Guidion B.V.

James Wattstraat 77-M, 1097 DL Amsterdam, The Netherlands

[privacy@guidion.net](mailto:privacy@guidion.net)

[https://www.guidion.com](https://www.guidion.com)

Your information will not be shared with any third parties.

## 3. What Data Do We Process?

* Photos of your electrical cabinet
* Technical metadata (timestamp, file format, device information)
* Contact details provided by you when using the service

## 4. Purposes and Legal Bases

### 4.1 Delivery of the Inspection Service

We process your photos to generate the Report. Legal basis: Performance of a contract (Art. 6(1)(b) GDPR).


### 4.2 Retention and Re-use of Photos

With your explicit consent, we retain photos for:

* Training, improving, and validating our AI models
* Quality control and further development of our services
* Internal research into safety standards for electrical installations
* Anonymized statistical analysis

Legal basis: Your consent (Art. 6(1)(a) GDPR). You can withdraw your consent at any time.


### 4.3 Waiver of Rights to Photos

You grant Guidion the necessary usage rights to process the photos for the purposes mentioned in Article 4.2, as long as your consent is active. Guidion will not sell photos to third parties or publish them publicly in an identifiable manner.

## 5. Retention Period

Guidion retains the photos for as long as necessary for the purposes mentioned in Article 4.2, with a maximum period of 2 years, or until you withdraw your consent or submit a deletion request.

## 6. Disclaimer — Nature and Limitations of the Report

Please read this section carefully. The Report is strictly for informational purposes and may not be used as an official inspection document.

### 6.1 The Report is strictly informational

The Report is an automatically generated overview of potential points of attention based on the provided photos. It is intended as an orientational summary for personal use only.

### 6.2 The Report is NOT a professional inspection report

The Report is explicitly not:

* An official inspection report in accordance with NEN 1010, NEN 3140, or other standards
* A statement from an accredited inspection body or certified installer
* Professional advice from a qualified electrician
* A declaration of conformity or safety for any purpose whatsoever

### 6.3 The Report is not legally binding

The Report cannot be used as:

* Evidence in legal or administrative proceedings
* Documentation for insurance claims or taking out insurance policies
* Required documentation for mortgage applications, or the sale or lease of real estate
* A mandatory inspection report required by law or regulation

### 6.4 Limitations of AI Analysis

The AI system analyzes purely based on visual information. Guidion does not guarantee the completeness or accuracy of the findings. Factors that are not visible in the photos—such as hidden cabling or wear and tear behind the installation—will not be detected.

### 6.5 Recommendation

If you have any doubts regarding the safety of your electrical installation, always hire a recognized and certified electrical installer or inspection body.

## 7. Aansprakelijkheidsbeperking

Guidion accepts no liability for damages resulting from:

* The use of or reliance on the contents of the Report
* Incorrect findings due to the quality of the provided photos
* Actions taken based on the Report
* Technical malfunctions or errors in the service

## 8. Uw rechten onder de AVG

You have the right to:

* Access your data (Art. 15 GDPR)
* Rectification of incorrect data (Art. 16 GDPR)
* Data erasure — "right to be forgotten" (Art. 17 GDPR)
* Restriction of processing (Art. 18 GDPR)
* Data portability (Art. 20 GDPR)
* Object to processing (Art. 21 GDPR)
* Withdraw consent at any time (Art. 7(3) GDPR)

## 9. Security

Guidion takes appropriate technical and organizational measures in accordance with the GDPR and ISO 27001 to secure your data.

## 10. Wijzigingen

Guidion reserves the right to amend this statement. Material changes will be announced in advance via the website or by email.

If you have any questions about this privacy statement or would like to learn more about how Guidion handles your personal data or what your rights are regarding your personal data, please contact our privacy department at privacy@guidion.net.

If this does not lead to a resolution or if you do not wish to wait for our response, you may exercise your right to file a complaint with the Dutch Data Protection Authority using the online complaint form on the website [https://www.autoriteitpersoonsgegevens.nl/en/submitting-a-tip-off-or-a-complaint-to-the-ap](https://www.autoriteitpersoonsgegevens.nl/en/submitting-a-tip-off-or-a-complaint-to-the-ap).

© 2026 Guidion B.V. — All rights reserved.
`,
    },
  },
};
